import FormPage from "@/components/FormPage";
import { api, IMAGES } from "@/lib/api";

export default function Volunteer() {
    return (
        <FormPage
            testIdPrefix="volunteer"
            eyebrow="Volunteer"
            title="Volunteer With Us"
            tagline="lend your heart"
            description="From event days to phone-tree check-ins — your time is invaluable. Tell us a little about you and we'll match you to a role that fits."
            heroImage={IMAGES.illustRight}
            accentColor="lime"
            fields={[
                { name: "name", label: "Full Name", required: true },
                { name: "email", label: "Email", type: "email", required: true },
                { name: "phone", label: "Phone", placeholder: "(optional)" },
                {
                    name: "availability", label: "Availability", type: "select",
                    options: [
                        { value: "weekdays", label: "Weekdays" },
                        { value: "weekends", label: "Weekends" },
                        { value: "evenings", label: "Evenings" },
                        { value: "flexible", label: "Flexible" },
                    ],
                },
                { name: "skills", label: "Skills / Interests", type: "textarea", placeholder: "e.g., tutoring, event setup, design, photography..." },
            ]}
            submitLabel="Sign Me Up"
            onSubmit={(v) => api.post("/volunteer", v)}
            successTitle="You're in! 🌟"
            successMessage="Welcome to the volunteer crew — we'll be in touch with upcoming opportunities."
        />
    );
}
